<template>
  <div class="gg-box">
  	<div class="gg-box-container">
  		<div class="gg-box-top">
  			<span>{{$t('all.gonggao')}}</span>
  			<img src="../../assets/image/tanchuang_x_b@2x.png" alt="关闭" @click="handleClose" />
  		</div>
		<div class="gg-box-content">
			<textarea v-model="noticeText" :placeholder="$t('all.qingshuru')"></textarea>
		</div>
		<div class="gg-box-btn">
			<div class="gg-box-btn-btn" @click="updNotice">{{$t('all.tijiao')}}</div>
		</div>
  	</div>
  </div>
</template>

<script>
import { getChatRoomDetails,updNotice } from "@/api/zhibo";
export default {
  data() {
    return {
	  noticeText:''
    };
  },
  mounted() {
	this.getChatRoomDetails()
  },
  methods: {
	async getChatRoomDetails(){
		const res = await getChatRoomDetails({liveId:this.$route.query.liveId})
		this.noticeText = res.data.chatRoomDetails.noticeText
	},
	//关闭公告
	handleClose(){
		this.$emit('close_gg')
	},
	//提交公告
	async updNotice(){
		const params = {
			noticeText:this.noticeText,
			liveId:this.$route.query.liveId
		}
		const res = await updNotice(params)
		this.$message({ message: res.msg,type: 'success'});
		this.$emit('close_gg')
	}

  }
};
</script>
<style scoped lang="scss">
	@import "./gonggao.css";
</style>


// WEBPACK FOOTER //
// gonggao.vue?e3c722e4